/* ── THEME (light / dark) ── */
function setThemeIcon(isDark){
  var moon = document.getElementById('themeIconMoon');
  var sun  = document.getElementById('themeIconSun');
  if(moon) moon.style.display = isDark ? 'none' : '';
  if(sun)  sun.style.display  = isDark ? '' : 'none';
}

(function(){
  var saved = localStorage.getItem('mnz-theme');
  if(saved === 'dark'){
    document.body.classList.add('dark');
    setThemeIcon(true);
  } else {
    setThemeIcon(false);
  }
})();

function toggleTheme(){
  var isDark = document.body.classList.toggle('dark');
  setThemeIcon(isDark);
  localStorage.setItem('mnz-theme', isDark ? 'dark' : 'light');
}

/* ── LANGUAGE SWITCHER ──
   U zhvendos në sections/header.liquid (mnzSetLang/mnzCycleLang) — kjo kopje
   e dublikuar e switchLang (sq↔en hardcoded) hiqet se linte mk të paarritshme. */

/* ── DRAWER MENU ── */
function openDrawer(){
  document.getElementById('sideDrawer').classList.add('open');
  document.getElementById('drawerOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeDrawer(){
  document.getElementById('sideDrawer').classList.remove('open');
  document.getElementById('drawerOverlay').classList.remove('open');
  document.body.style.overflow = '';
}

function like(btn,lid){
  const on=btn.getAttribute('data-on')==='1';
  const el=document.getElementById(lid);
  const n=parseInt(el.textContent.replace(/[^0-9]/g,''));
  if(!on){
    btn.style.stroke='#ed4956';btn.style.fill='#ed4956';
    btn.setAttribute('data-on','1');
    btn.classList.add('popped');
    setTimeout(()=>btn.classList.remove('popped'),300);
    el.textContent=(n+1).toLocaleString()+' likes';
  } else {
    btn.style.stroke='var(--text)';btn.style.fill='none';
    btn.setAttribute('data-on','0');
    el.textContent=(n-1).toLocaleString()+' likes';
  }
}

function activatePost(inp){
  inp.nextElementSibling.classList.toggle('on',inp.value.trim().length>0);
}

var BS_FILTER_HREFS={
  'te-gjitha':'/collections/all',
  'meshkuj':'/collections/meshkuj',
  'femna':'/collections/femra',
  'zbritje':'/collections/zbritje'
};

function bsFilterClick(e,btn,cat){
  var grid=document.getElementById('bestSellingGrid');
  if(!grid) return true;
  e.preventDefault();

  document.querySelectorAll('.filter-btn').forEach(function(b){ b.classList.remove('active'); });
  btn.classList.add('active');

  var initial=parseInt(grid.getAttribute('data-initial'),10)||18;
  var shown=0;
  grid.querySelectorAll('.product-card').forEach(function(card){
    var cats=' '+(card.getAttribute('data-cat')||'')+' ';
    var match=cats.indexOf(' '+cat+' ')!==-1;
    if(match && shown<initial){
      card.style.display='';
      shown++;
    } else {
      card.style.display='none';
    }
  });

  var moreBtn=document.getElementById('bsSeeMoreBtn');
  if(moreBtn) moreBtn.setAttribute('href', BS_FILTER_HREFS[cat]||'/collections/all');

  return false;
}

function seeMore(){
  const extras=document.querySelectorAll('.grid-post.extra');
  extras.forEach(e=>e.style.display='');
  document.getElementById('seeMoreBtn').style.display='none';
}

function playReel(card){
  const thumb=card.querySelector('.reel-thumb');
  const vid=card.querySelector('.reel-video-wrap');
  if(vid.style.display==='none'){
    thumb.style.opacity='1';
    vid.style.display='block';
    vid.style.opacity='0';
    requestAnimationFrame(function(){
      thumb.style.opacity='0';
      vid.style.opacity='1';
    });
    setTimeout(function(){
      thumb.style.display='none';
      thumb.style.opacity='';
    },180);
    const v=vid.querySelector('video');
    const muteBtn=vid.querySelector('.reel-mute-btn');
    if(v){
      v.muted=false;
      v.play().catch(function(){
        v.muted=true;
        if(muteBtn) muteBtn.textContent='🔇';
        v.play();
      });
      if(muteBtn) muteBtn.textContent='🔊';
    }
  }
}

function closeReel(e,btn){
  e.stopPropagation();
  const card=btn.closest('.reel-card');
  card.querySelector('.reel-thumb').style.display='block';
  card.querySelector('.reel-video-wrap').style.display='none';
  const v=card.querySelector('.reel-video-wrap video');
  if(v){ v.pause(); v.muted=true; }
  const muteBtn=card.querySelector('.reel-mute-btn');
  if(muteBtn) muteBtn.textContent='🔇';
}

function toggleReelMute(e,btn){
  e.stopPropagation();
  const v=btn.closest('.reel-video-wrap').querySelector('video');
  if(!v) return;
  v.muted=!v.muted;
  btn.textContent=v.muted?'🔇':'🔊';
}

function pcSwap(card,src){
  const img=card.querySelector('.p-card-img');
  if(img && src) img.src=src;
}

function _storyIds(){
  return Array.from(document.querySelectorAll('[data-story-id]')).map(function(c){return c.getAttribute('data-story-id');});
}

function openStory(id){
  /* Build slides: MNZ_SL first, fallback to poster image */
  var slides = window.MNZ_SL&&window.MNZ_SL[id]&&window.MNZ_SL[id].length ? window.MNZ_SL[id] : null;
  if(!slides){
    var viewer=document.getElementById('viewer-'+id);
    var img=viewer?viewer.querySelector('.story-viewer-media img'):null;
    if(img&&img.src){
      slides=[{img:img.src,title:'',price:'',url:''}];
      window.MNZ_SL=window.MNZ_SL||{};
      window.MNZ_SL[id]=slides;
    }
  }
  if(slides&&slides.length){ mnzGallOpen(id); return; }
  /* fallback: video story viewer */
  document.querySelectorAll('.story-viewer.open').forEach(function(v){
    v.classList.remove('open');
    var vid=v.querySelector('video'); if(vid) vid.pause();
  });
  var v=document.getElementById('viewer-'+id);
  if(!v) return;
  v.classList.add('open');
  var vid=v.querySelector('video');
  if(vid){
    vid.currentTime=0;
    var bar=v.querySelector('.story-viewer-progress');
    if(bar){
      var syncBar=function(){ bar.style.animation='storyProgress '+(vid.duration||5)+'s linear'; };
      if(vid.duration){ syncBar(); } else { vid.addEventListener('loadedmetadata', syncBar, {once:true}); }
    }
    vid.loop=false;
    vid.onended=function(){
      var ids=_storyIds();
      var nextIdx=ids.indexOf(id)+1;
      closeStory(id);
      if(nextIdx>0&&nextIdx<ids.length){ openStory(ids[nextIdx]); }
    };
    vid.play();
  }
  var ring=document.getElementById('ring-'+id);
  if(ring) ring.classList.add('seen');
  document.body.style.overflow='hidden';
}

function closeStory(id){
  var viewer=document.getElementById('viewer-'+id);
  if(!viewer) return;
  viewer.classList.remove('open');
  var vid=viewer.querySelector('video'); if(vid) vid.pause();
  document.body.style.overflow='';
}

var _mnzG={data:[],idx:0,timer:null,id:null};
function mnzGallOpen(id){
  var d=window.MNZ_SL&&window.MNZ_SL[id];
  if(!d||!d.length) return;
  _mnzG.data=d; _mnzG.idx=0; _mnzG.id=id;
  var ring=document.getElementById('ring-'+id);
  if(ring) ring.classList.add('seen');
  var pb=document.getElementById('mnzGallPb');
  pb.innerHTML='';
  d.forEach(function(_,i){
    var w=document.createElement('div');
    w.style.cssText='flex:1;height:2px;background:rgba(255,255,255,.3);border-radius:1px;overflow:hidden';
    var f=document.createElement('div');
    f.id='mnz-gpb-'+i;
    f.style.cssText='width:0;height:100%;background:#fff;border-radius:1px;transition:none';
    w.appendChild(f); pb.appendChild(w);
  });
  var gv=document.getElementById('mnzGallViewer');
  gv.style.display='block';gv.style.visibility='visible';
  document.body.style.overflow='hidden';
  mnzGallShow();
}
function mnzGallShow(){
  var d=_mnzG.data[_mnzG.idx];
  var wa=window.MNZ_WA_NUM||'';
  document.getElementById('mnzGallImg').src=d.img;
  document.getElementById('mnzGallWA').href='https://wa.me/'+wa+'?text='+encodeURIComponent('Po dua te porosis: '+d.title+'\n'+location.origin+(d.url||''));
  _mnzG.data.forEach(function(_,i){
    var b=document.getElementById('mnz-gpb-'+i);
    if(!b) return;
    b.style.transition='none';
    b.style.width=i<_mnzG.idx?'100%':'0%';
  });
  setTimeout(function(){
    var b=document.getElementById('mnz-gpb-'+_mnzG.idx);
    if(b){b.style.transition='width 5s linear';b.style.width='100%';}
  },30);
  clearInterval(_mnzG.timer);
  _mnzG.timer=setInterval(mnzGallNext,5000);
}
function mnzGallNext(){
  clearInterval(_mnzG.timer);
  if(_mnzG.idx<_mnzG.data.length-1){
    _mnzG.idx++; mnzGallShow(); return;
  }
  /* Last slide — go to next story like Instagram */
  var ids=_storyIds();
  var nextIdx=ids.indexOf(_mnzG.id)+1;
  if(nextIdx>0&&nextIdx<ids.length){
    mnzView(ids[nextIdx]);
    mnzGallOpen(ids[nextIdx]);
  } else {
    mnzGallClose();
  }
}
function mnzGallPrev(){
  clearInterval(_mnzG.timer);
  if(_mnzG.idx>0){ _mnzG.idx--; mnzGallShow(); return; }
  /* First slide — go to prev story */
  var ids=_storyIds();
  var prevIdx=ids.indexOf(_mnzG.id)-1;
  if(prevIdx>=0){ mnzGallOpen(ids[prevIdx]); }
}
function mnzGallClose(){
  clearInterval(_mnzG.timer);
  var gv=document.getElementById('mnzGallViewer');
  gv.style.display='none';gv.style.visibility='hidden';
  document.body.style.overflow='';
}

(function(){
  var gv=document.getElementById('mnzGallViewer');
  if(!gv) return;
  var tx=0,ty=0,lastTouch=0;

  gv.addEventListener('touchstart',function(e){
    tx=e.changedTouches[0].clientX;
    ty=e.changedTouches[0].clientY;
  },{passive:true});

  gv.addEventListener('touchend',function(e){
    lastTouch=Date.now();
    if(e.target.closest('a,button')) return;
    var dx=e.changedTouches[0].clientX-tx;
    var dy=e.changedTouches[0].clientY-ty;
    if(Math.abs(dx)<12&&Math.abs(dy)<12){
      /* tap — majtas=back, djathtas=next */
      if(tx<window.innerWidth/2) mnzGallPrev(); else mnzGallNext();
    } else if(Math.abs(dx)>Math.abs(dy)&&Math.abs(dx)>40){
      /* swipe horizontal */
      if(dx<0) mnzGallNext(); else mnzGallPrev();
    }
  },{passive:true});

  /* desktop click — mos firo nese erdhi nga touch */
  gv.addEventListener('click',function(e){
    if(Date.now()-lastTouch<600) return;
    if(e.target.closest('a,button')) return;
    if(e.clientX<window.innerWidth/2) mnzGallPrev(); else mnzGallNext();
  });
})();

(function(){
  var nav=document.querySelector('nav');
  if(!nav) return;
  function chk(){
    nav.classList.toggle('nav-scrolled',window.scrollY>60);
  }
  window.addEventListener('scroll',chk,{passive:true});
  window.addEventListener('resize',chk,{passive:true});
  chk();
})();

/* .nav-bg shrinks by an exact 8px on each side when scrolled (the "pill"). A CSS
   scaleX can't express a fixed-pixel inset on its own (it's relative to the element's
   own width), so we compute the exact ratio here and hand it to CSS as a custom
   property — the actual scroll-triggered animation then runs purely on the GPU
   via transform, this only recalculates on load/resize, never on scroll. */
(function(){
  function updateNavPillScale(){
    var w=window.innerWidth;
    if(!w) return;
    var scale=(w-16)/w;
    document.documentElement.style.setProperty('--nav-pill-scale',scale.toFixed(4));
  }
  updateNavPillScale();
  var t;
  window.addEventListener('resize',function(){
    clearTimeout(t);
    t=setTimeout(updateNavPillScale,150);
  });
})();

(function(){
  function initFilterPills(){
    var btns=document.querySelectorAll('.filter-btn[data-bs-cat]');
    if(!btns.length) return;
    for(var i=0;i<btns.length;i++){
      btns[i].addEventListener('click',function(){
        var cat=this.getAttribute('data-bs-cat');
        var grid=document.getElementById('bestSellingGrid');
        if(!grid) return;
        for(var j=0;j<btns.length;j++) btns[j].classList.remove('active');
        this.classList.add('active');
        var cards=grid.querySelectorAll('.product-card');
        var initial=parseInt(grid.getAttribute('data-initial'),10)||18;
        var shown=0;
        for(var k=0;k<cards.length;k++){
          var p=cards[k];
          var cats=' '+(p.getAttribute('data-cat')||'')+' ';
          var match=cats.indexOf(' '+cat+' ')!==-1;
          if(match&&shown<initial){p.style.display='';shown++;}
          else{p.style.display='none';}
        }
        var moreBtn=document.getElementById('bsSeeMoreBtn');
        if(moreBtn) moreBtn.style.display=cat==='te-gjitha'?'':'none';
        grid.scrollIntoView(false);
      });
    }
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initFilterPills);
  } else {
    initFilterPills();
  }
})();

/* Product-card image swap on hover — real-hover devices only.
   Attaching mouseenter/mouseleave to an <a href> (even via addEventListener)
   makes iOS Safari / some Android browsers require a second tap to actually
   navigate (first tap only "simulates" hover). Gating on pointer:fine+hover:hover
   means touch-only devices get zero mouse listeners on the card, so a single
   tap always navigates straight to the product. */
(function(){
  if(!window.matchMedia || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  document.querySelectorAll('.product-card[data-img-alt]').forEach(function(card){
    var img=card.querySelector('.p-card-img');
    if(!img) return;
    var mainSrc=img.getAttribute('src');
    var altSrc=card.getAttribute('data-img-alt');
    if(!altSrc || altSrc===mainSrc) return;
    card.addEventListener('mouseenter',function(){img.src=altSrc;});
    card.addEventListener('mouseleave',function(){img.src=mainSrc;});
  });
})();

